/** QWERTY keyboard to MIDI note mapping.
 *
 * Two-row layout covering roughly 2 octaves (C3–F4):
 *
 *   Row 1 (upper):  W  E     T  Y  U     O  P
 *                   C# D#   F# G# A#   C# D#    ← Black keys
 *   Row 0 (lower): A  S  D  F  G  H  J  K  L  ;  '
 *                   C  D  E  F  G  A  B  C  D  E  F  ← White keys
 */

/** Map from keyboard key to MIDI note number. */
export type KeyMap = Readonly<Record<string, number>>;

/** Base octave offset (C3 = MIDI 48). */
const BASE_NOTE = 48;

/** Default QWERTY → MIDI note mapping. */
export const KEY_MAP: KeyMap = {
	// Lower row: white keys (C3–F4)
	a: BASE_NOTE + 0, // C3
	s: BASE_NOTE + 2, // D3
	d: BASE_NOTE + 4, // E3
	f: BASE_NOTE + 5, // F3
	g: BASE_NOTE + 7, // G3
	h: BASE_NOTE + 9, // A3
	j: BASE_NOTE + 11, // B3
	k: BASE_NOTE + 12, // C4
	l: BASE_NOTE + 14, // D4
	";": BASE_NOTE + 16, // E4
	"'": BASE_NOTE + 17, // F4

	// Upper row: black keys (C#3–D#4)
	w: BASE_NOTE + 1, // C#3
	e: BASE_NOTE + 3, // D#3
	t: BASE_NOTE + 6, // F#3
	y: BASE_NOTE + 8, // G#3
	u: BASE_NOTE + 10, // A#3
	o: BASE_NOTE + 13, // C#4
	p: BASE_NOTE + 15, // D#4
} as const;

/** Keys for octave shift: Z = down, X = up. */
export const OCTAVE_DOWN_KEY = "z" as const;
export const OCTAVE_UP_KEY = "x" as const;

/** Get the MIDI note for a key press, applying octave offset. */
export function getNoteForKey(
	key: string,
	octaveOffset: number,
): number | undefined {
	const baseNote = KEY_MAP[key.toLowerCase()];
	if (baseNote === undefined) return undefined;
	return baseNote + octaveOffset * 12;
}
